import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IHelp } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class HelpApiService {

  abstract get currentHelpTopicValue(): string;

  abstract setCurrentHelpTopicValue(topic: string): void;

  abstract getList(): Observable<IHelp[]>;

  abstract getItem(id: string): Observable<IHelp>;

}